/// <amd-module name="Pipeline/Analytics/TaskInsights/Constants" />
export const serviceInstanceId = "0000003c-0000-8888-8000-000000000000";

export const taskInsightsFF = "WebAccess.Pipeline.TaskInsights";

export const TaskInsightsDismissalKey = "TaskInsights/MessageDismissed";

export namespace Telemetry {
    export const Area = "TaskInsights";
    export const TaskInsightsViewReport = "TaskInsightsViewReport";
    export const TaskInsightsOnError = "TaskInsightsOnError";
    export const TaskInsightsOnDismiss = "TaskInsightsOnDismiss";
}
